// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".H2HMv5mkLTHm1tVVQjU2aw\\=\\={margin:50px 60px}.eZv-MErYQ\\+MW8XLCC-FGRA\\=\\={float:right}._1UX3-A4TptX85gLtETa9Yg\\=\\={margin-bottom:20px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Teams/MembersList.module.css"],"names":[],"mappings":"AAAA,4BAEI,gBACJ,CAEA,6BACI,WACJ,CAEA,6BACI,kBACJ","sourcesContent":[".tabsContainer {\n\n    margin: 50px 60px;\n}\n\n.inviteMemberButton {\n    float: right;\n}\n\n.topButtonsContainer {\n    margin-bottom: 20px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabsContainer": "H2HMv5mkLTHm1tVVQjU2aw==",
	"inviteMemberButton": "eZv-MErYQ+MW8XLCC-FGRA==",
	"topButtonsContainer": "_1UX3-A4TptX85gLtETa9Yg=="
};
export default ___CSS_LOADER_EXPORT___;
